import styled from 'styled-components'

export const Container = styled.section`
  max-width: 960px;
  color: #4b4e51;
  padding: 78px 32px 32px;
  margin: auto;

  h1 {
    padding: 16px 0;
    margin: 15px 0;
    text-align: center;
    font-size: 22px;
  }

  h2 {
    padding: 20px 0;
    font-size: 20px;
  }

  p {
    padding-bottom: 16px;
    font-size: 15px;
    line-height: 24px;
  }
`

export const TopLogoSection = styled.section`
  padding: 17px 20px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  img {
    padding: 10px;
    width: 140px;
    object-fit: contain;
  }
`

export const OrderedList = styled.ol`
  h3 {
    padding: 16px 0;
  }
  ul {
    list-style-type: disc;
    padding-left: 15px;
  }

  ul li {
    margin-bottom: 10px;
  }
`
